<template>
  <section>
    <v-card class="box-shadow" v-if="profile_type && profile_type === 'aspiringSolicitor' && user_study_group">
      <v-list-item v-if="user_study_group.status === 'requested'">
        <v-list-item-content class="unselectable">
          Your request is pending. The result will be sent to you by email.
          <!--                    <pre>{{ user_study_group }}</pre>-->
        </v-list-item-content>
        <v-list-item-action>
          <div class="">
            <v-btn small color="primary" @click="openRequestDialog"><v-icon>mdi-cog</v-icon></v-btn>
          </div>
        </v-list-item-action>
      </v-list-item>

      <v-list-item v-if="user_study_group.status === 'invited'">
        <v-list-item-content class="unselectable">
          You have been invited to a study group. Do you want to accept the invitation?
        </v-list-item-content>
        <v-list-item-action>
          <div class="">
            <v-btn small color="error" @click="deleteInvitation"><v-icon>mdi-cancel</v-icon></v-btn>
            <v-btn small color="success" @click="openInvitationDialog"><v-icon>mdi-check</v-icon></v-btn>
          </div>
        </v-list-item-action>
      </v-list-item>

      <v-list-item v-if="user_study_group.status === 'approved'">
        <v-list-item-content class="unselectable">
          <p class="ma-0">You are a member of this group. Press
            <span @click="openRequestDialog">
              <v-icon small>mdi-cog</v-icon>
            </span> to change settings</p>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn small color="primary" @click="openSettingsDialog"><v-icon>mdi-cog</v-icon></v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card>

    <v-alert v-if="study_group && !open && !user_study_group" class="box-shadow mb-0" type="error" prominent>
      Enrollment in this group is closed
    </v-alert>

<!--    <v-container fluid>-->
<!--      <v-row >-->
<!--        <v-col cols="12" md="6">x</v-col>-->
<!--        <v-col cols="12" md="6">-->
<!--          <v-card>-->
<!--            <v-sheet max-height="400px"></v-sheet>-->
<!--            <v-card-text>-->


<!--            </v-card-text>-->
<!--            <v-divider/>-->
<!--            <v-card-actions>-->
<!--              <v-text-field hide-details solo-inverted dense></v-text-field>-->
<!--              <v-btn icon><v-icon>mdi-send</v-icon></v-btn>-->
<!--            </v-card-actions>-->
<!--          </v-card>-->
<!--        </v-col>-->
<!--      </v-row>-->
<!--    </v-container>-->

    <v-dialog v-model="invitation_dialog" max-width="700px" @click:outside="closeInvitationDialog">
      <v-form @submit="acceptInvitation">
        <v-card>
          <v-toolbar color="primary" dense dark>
            Invitation<v-spacer/>
            <v-btn icon @click="closeInvitationDialog"> <v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>

          <v-card-text class="pt-3" v-if="invitation">
            <v-select label="OSCE P1 exam dates"
                      v-model="invitation.study_sub_group_id"
                      :items="study_group.study_sub_groups"
                      item-value="id"
                      item-text="p1_exam_dates"
                      prepend-icon="mdi-account-group"
            >
              <template v-slot:item="{ item }">
                <span class="font-weight-bold">{{ item.name }} - </span>
                <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">
                    {{ $moment(exam_date).format('DD/MM/YYYY') }},
                  </span>
              </template>

              <template v-slot:selection="{ item }">
                <span class="font-weight-bold">{{ item.name }} - </span>
                <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">
                    {{ $moment(exam_date).format('DD/MM/YYYY') }},
                  </span>
              </template>
            </v-select>

            <v-select id="firstQuestion"
                      v-model="first_answer"
                      :items="first_answer_options"
                      :label="first_question"
            />

            <v-switch label="Is Sunday your day off?" v-model="invitation.sunday_day_off"/>

            <template v-if="first_answer === 'working' || first_answer === 'working_before_exam'">
              <v-subheader>Indicate any time off work/studies within your preparation period when you are available for mock sessions 7 days a week</v-subheader>
              <date-field v-model="invitation.training_start" label="From"/>
              <date-field v-model="invitation.training_end" label="Till"/>
            </template>
          </v-card-text>
          <v-divider/>
          <v-card-actions class="justify-center">
            <v-btn color="error" @click="deleteInvitation">Decline</v-btn>
            <v-btn color="success" type="submit">Accept</v-btn>
          </v-card-actions>
          <!--        <pre>{{ invitation }}</pre>-->
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="request_dialog" max-width="700px" @click:outside="closeRequestDialog">
      <v-card>
        <v-toolbar color="primary" dark>
          Join request<v-spacer/>
          <v-btn icon @click="closeRequestDialog"> <v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="pt-3" v-if="request">
          <v-select label="OSCE P1 exam dates"
                    v-model="request.study_sub_group_id"
                    :items="study_group.study_sub_groups"
                    item-value="id"
                    item-text="p1_exam_dates"
                    prepend-icon="mdi-account-group"
          >
            <template v-slot:item="{ item }">
              <span class="font-weight-bold">{{ item.name }} - </span>
              <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">
                    {{ $moment(exam_date).format('DD/MM/YYYY') }},
                  </span>
            </template>

            <template v-slot:selection="{ item }">
              <span class="font-weight-bold">{{ item.name }} - </span>
              <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">
                    {{ $moment(exam_date).format('DD/MM/YYYY') }},
                  </span>
            </template>
          </v-select>

          <template v-if="request.visitation_type === 'G2' || request.visitation_type === 'G3'">
            <v-switch label="Is Sunday your day off?" v-model="request.sunday_day_off"/>
            <v-subheader>Your preparation period</v-subheader>
            <DateField label="From" v-model="request.training_start"/>
            <DateField label="Till" v-model="request.training_end"/>
            <v-subheader>Summary</v-subheader>
            <v-textarea outlined v-model="request.summary"></v-textarea>
          </template>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="justify-center">
          <v-btn color="error" @click="closeRequestDialog">Decline</v-btn>
          <v-btn color="success" @click="updateRequest">Resend</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="settings_dialog" max-width="700px" @click:outside="closeSettingsDialog">
      <v-card>
        <v-toolbar color="primary" dark>
          Settings<v-spacer/>
          <v-btn icon @click="closeSettingsDialog"> <v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="pt-3" v-if="settings">
          <v-select label="OSCE P1 exam dates"
                    v-model="settings.study_sub_group_id"
                    :items="study_group.study_sub_groups"
                    item-value="id"
                    item-text="p1_exam_dates"
                    prepend-icon="mdi-account-group"
          >
            <template v-slot:item="{ item }">
              <span class="font-weight-bold">{{ item.name }} - </span>
              <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">
                    {{ $moment(exam_date).format('DD/MM/YYYY') }},
                  </span>
            </template>

            <template v-slot:selection="{ item }">
              <span class="font-weight-bold">{{ item.name }} - </span>
              <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">
                    {{ $moment(exam_date).format('DD/MM/YYYY') }},
                  </span>
            </template>
          </v-select>

          <v-switch label="Is Sunday your day off?" v-model="settings.sunday_day_off"/>

          <template v-if="settings.visitation_type === 'G2' || settings.visitation_type === 'G3'">
            <v-subheader>Your preparation period</v-subheader>
            <DateField label="From" v-model="settings.training_start"/>
            <DateField label="Till" v-model="settings.training_end"/>
          </template>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="justify-space-between">
          <v-btn color="error" @click="deleteInvitation">Leave</v-btn>
          <v-btn color="success" @click="updateSettings">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card flat tile v-if="study_group && study_group.booking_policy">
      <v-card-text  v-html="study_group.booking_policy"></v-card-text>
    </v-card>

  </section>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import DateField from "@/components/DateField";

export default {
  components: {DateField},
  props: {
    study_group: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    invitation_dialog: false,
    invitation: null,
    request_dialog: false,
    request: null,
    settings_dialog: false,
    settings: null,

    edited_usg_dialog: false,
    edited_usg: null,


    first_question: 'Please indicate your availability for exam preparation',
    first_answer_options: [
      {
        text: 'I am flexible (freelancer) or I do not work at all and won’t be working until/after the exam',
        value: 'not_working',
      },
      {
        text: 'I work all working days, and will get less than 2 weeks off work before the exam',
        value: 'not_intensive_working',
      },
      {
        text: 'I work all working days, but will get more than 2 weeks off work before the exam',
        value: 'working',
      },
      {
        text: 'I am not working now, but will get back to work closer to the exam time',
        value: 'working_before_exam',
      },
    ],
    first_answer: '',
    api_errors: []
  }),
  computed: {
    ...mapGetters({
      profile_type: 'getAuthUserProfileType',
      profile_type_label: 'getAuthUserProfileTypeLabel',
      authUserStudyGroups: 'getAuthUserStudyGroups',
    }),
    user_study_group: function () {
      if(this.study_group) {
        return this.authUserStudyGroups.find(user_study_group => user_study_group.study_group_id === this.study_group.id)
      }
      return null
    },
    open: function () {
      if(this.study_group) {
        let open = this.$moment(this.study_group.recruitment_start)
        let close = this.$moment(this.study_group.recruitment_end)
        return this.$currentTime().isBetween(open, close)
      }
      return null
    }
  },
  methods: {
    ...mapActions({loadAuthUserStudyGroups: 'loadAuthUserStudyGroups'}),
    openInvitationDialog() {
      this.invitation = Object.assign({}, this.user_study_group)
      this.invitation_dialog = true
    },
    closeInvitationDialog() {
      this.invitation_dialog = false
      this.invitation = null
    },
    acceptInvitation(e) {
      e.preventDefault()
      this.api_errors = []
      this.app_loading = true
      this.invitation.action = 'approve'
      this.axios.put(`api/user/study-groups/${this.invitation.id}`, this.invitation)
        .then(() => {
          this.loadAuthUserStudyGroups()
          this.closeInvitationDialog()
          this.api_errors = []
        })
        .catch(errors => {this.api_errors = errors.response.data.errors})
        .then(() => {this.app_loading = false})
    },
    deleteInvitation() {
      this.axios.delete(`api/user/study-groups/${this.user_study_group.id}`)
      this.loadAuthUserStudyGroups()
      this.closeInvitationDialog()
      this.closeSettingsDialog()
    },
    openRequestDialog() {
      this.request = Object.assign({}, this.user_study_group)
      this.request_dialog = true
    },
    closeRequestDialog() {
      this.request_dialog = false
      this.request = null
    },
    updateRequest() {
      if(!this.request) return ;
      this.api_errors = []
      this.app_loading = true
      this.axios.put(`api/user/study-groups/${this.request.id}`, this.request)
        .then(() => {
          this.loadAuthUserStudyGroups()
          this.closeRequestDialog()
        })
        .catch((errors) => {this.api_errors = errors.response.data.errors})
        .then(() => {this.app_loading = false})
    },
    openSettingsDialog() {
      this.settings = Object.assign({}, this.user_study_group)
      this.settings_dialog = true
    },
    closeSettingsDialog() {
      this.settings_dialog = false
      this.settings = null
    },
    updateSettings() {
      this.api_errors = []
      this.app_loading = true
      this.axios.put(`api/user/study-groups/${this.settings.id}`, this.settings)
          .then(() => {
            this.loadAuthUserStudyGroups()
            this.closeSettingsDialog()
          })
          .catch((errors) => {this.api_errors = errors.response.data.errors})
          .then(() => {this.app_loading = false})
    },
  }

}
</script>